import { ThemeProvider } from '@material-ui/core';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Login from './components/Auth/Login';
import Nav from './components/layout/Nav';
import { useAuth } from './contexts/AuthContext';
import { useTheme } from './contexts/ThemeContext';
import AuthLoading from './components/layout/AuthLoading';
import AddTask from './components/tasks/AddTask';
import Balance from './components/balance/Balance';
import Tasks from './components/tasks/Tasks';
import { TaskProvider } from './contexts/TaskContext'
import ReceivedTasks from './components/tasks/ReceivedTasks';
function App() {
  const { currentUser, authLoading } = useAuth()
  const { darkTheme, lightTheme, isDark } = useTheme()
  return (
      <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      <Router>
        {(authLoading) ?
          // loading screen when user is logged in
          <AuthLoading />
        : (!currentUser) ?
          <Login />
          :
            // when user is logged in 
          <Nav>
            <TaskProvider>
              <Switch>
                <Route exact path="/">
                  <Tasks />
                </Route>
                <Route path="/addTask">
                  <AddTask />    
                  </Route>
                <Route path="/balance">
                  <Balance />    
                  </Route>
                  <Route path="/received">
                  <ReceivedTasks />    
                </Route>
              </Switch>
            </TaskProvider>
          </Nav>
        }
        </Router>
      </ThemeProvider>
  );
}

export default App;
